import script from "./inputComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./inputComponent.vue?vue&type=script&setup=true&lang=js"

import "./inputComponent.vue?vue&type=style&index=0&id=366ce2a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-366ce2a6"]])

export default __exports__